'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _Vas = require('../Vas');

var _Vas2 = _interopRequireDefault(_Vas);

require('../css/DatePicker.css');

var _utilsLib = require('utils-lib');

var _SelectField = require('./SelectField');

var _SelectField2 = _interopRequireDefault(_SelectField);

var _PagingButton = require('./PagingButton');

var _PagingButton2 = _interopRequireDefault(_PagingButton);

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _PopUpBox = require('./PopUpBox');

var _PopUpBox2 = _interopRequireDefault(_PopUpBox);

var _ExtendedButton = require('./ExtendedButton');

var _ExtendedButton2 = _interopRequireDefault(_ExtendedButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//import Vas from '../../build/Vas';

var moment = require('moment');
moment().format();

var DatePicker = function (_Component) {
    _inherits(DatePicker, _Component);

    //#region Komponente und Reaktionen
    function DatePicker(props) {
        _classCallCheck(this, DatePicker);

        var _this = _possibleConstructorReturn(this, (DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).call(this, props));

        _this.state = {};

        _this.state.referenceId = _this.props.ReferenceId;
        _this.state.id = _this.props.Id;

        _this.state.default = _this.props.Default;
        _this.state.isPicker = true;
        _this.state.WeekLines = [];
        _this.state.MinValue = _this.props.MinValue;
        _this.state.MaxValue = _this.props.MaxValue;
        _this.state.ShowDay = _this.props.ShowDay !== null && _this.props.ShowDay !== undefined ? _this.props.ShowDay : true;
        _this.state.currentYear = _this.getselectedDay().year();
        _this.state.currentMonth = _this.getselectedDay().month();
        _this.state.years = _this.GetYears();
        return _this;
    }

    _createClass(DatePicker, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var me = this;

            (0, _jquery2.default)(document).on("click", function (e) {
                var tar = e.target;
                if (tar.tagName !== "OPTION" && (tar.tagName === "IMG" && tar.id === "Kalender") === false) {
                    if (_utilsLib.CheckValues.includes(tar.id, "dp")[0] === false) {
                        while (tar) {
                            if (tar.parentElement) {
                                if (tar.parentElement.id) {
                                    var name = tar.parentElement.id;
                                    var popup = name.substr(0, 8);

                                    if (popup === "PopUpBox") {
                                        var dp = name.substr(8, 2);
                                        if (dp !== "dp") {

                                            me.props.reference.ClosePicker(me.props.reference);
                                        } else {
                                            break;
                                        }
                                    } else {

                                        me.props.reference.ClosePicker(me.props.reference);
                                    }
                                }
                            }
                            tar = tar.parentNode;
                        }
                    }
                }
            });

            if (this.state.MinValue) {
                var minValue = this.state.MinValue;
                var day = void 0;
                if (minValue._i) {
                    day = minValue._i[2];
                    if (day > _utilsLib.DateTimeHelper.GetLastDayOfMonth(minValue._i[1], minValue._i[0])) {
                        day--;
                    }
                    this.setState({ MinValue: moment([minValue._i[0], minValue._i[1], day]) }, function () {
                        _this2.setWeekLines();
                    });
                } else {
                    day = minValue.date();
                    if (day > _utilsLib.DateTimeHelper.GetLastDayOfMonth(minValue.month(), minValue.year())) {
                        day--;
                    }
                    this.setState({ MinValue: moment([minValue.year(), minValue.month(), day]) }, function () {
                        _this2.setWeekLines();
                    });
                }
            } else {
                this.setWeekLines();
            }

            this.SetMonthData();
            document.getElementById("PopUpBox" + this.props.Id).focus();

            this.LogoClick();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            (0, _jquery2.default)(document).unbind("click");
            // $(document).unbind("keyup");
        }
    }, {
        key: 'getselectedDay',
        value: function getselectedDay() {
            var today = moment();

            if (this.props.Default) {
                if (this.props.DefaultVal) {
                    if (this.state.ShowDay === true) {
                        today = _utilsLib.DateTimeHelper.StringToDate(this.props.DefaultVal, false, this.props.Language);
                    } else {
                        if (this.state.ShowDay === false) {
                            var curDate = _utilsLib.DateTimeHelper.StringToDate(this.props.DefaultVal, false, this.props.Language, false);
                            curDate.date(_utilsLib.DateTimeHelper.GetLastDayOfMonth(curDate.month(), curDate.year()));
                            today = curDate;
                        }
                    }
                } else {
                    today = moment();
                }
            }
            var pickerMinMax = this.getPickerMinMax();
            switch (pickerMinMax) {
                case '00':
                    {
                        //kein Min und kein Max
                        today = this.switchFirstLast(today);
                        break;
                    }
                case '01':
                    {
                        //kein Min aber Max
                        var max = moment(this.state.MaxValue);
                        today = this.switchFirstLast(today, max);
                        break;
                    }
                case '10':
                    {
                        var min = moment(this.state.MinValue);
                        today = this.switchFirstLast(today, null, min);
                        break;
                    }
                case '11':
                    {
                        var dayMax = moment(this.state.MaxValue);
                        var dayMin = moment(this.state.MinValue);
                        today = this.switchFirstLast(today, dayMax, dayMin);
                        break;
                    }
                default:
                    break;
            }
            return today;
        }
    }, {
        key: 'switchFirstLast',
        value: function switchFirstLast(today, max, min) {
            var pickerFirstLast = this.getPickerFirstLast();
            switch (pickerFirstLast) {
                case '00':
                    {
                        //kein First unde kein Last
                        if (max) {
                            if (max.isBefore(today) === true) {
                                today = max;
                            }
                        }
                        if (min) {
                            if (min.isAfter(today) === true) {
                                today = min;
                            }
                        }
                        break;
                    }
                case '01':
                    {
                        //Last
                        if (max) {
                            if (max.isBefore(today) === true) {
                                if (max.month() === today.month()) {
                                    today = moment([max.year(), max.month() - 1, _utilsLib.DateTimeHelper.GetLastDayOfMonth(max.month() - 1, max.year())]);
                                } else {
                                    today = max;
                                    if (today.date() !== _utilsLib.DateTimeHelper.GetLastDayOfMonth(today.month(), today.year())) {
                                        today = moment([today.year(), today.month() - 1, _utilsLib.DateTimeHelper.GetLastDayOfMonth(today.month() - 1, today.year())]);
                                    }
                                }
                            } else {
                                if (today.date() !== _utilsLib.DateTimeHelper.GetLastDayOfMonth(today.month(), today.year())) {
                                    today = moment([today.year(), today.month(), _utilsLib.DateTimeHelper.GetLastDayOfMonth(today.month(), today.year())]);
                                }
                            }
                        }
                        if (min) {
                            if (min.isAfter(today) === true) {
                                if (min.month() === today.month()) {
                                    today = moment([min.year(), min.month(), _utilsLib.DateTimeHelper.GetLastDayOfMonth(min.month(), min.year())]);
                                } else {
                                    today = min;
                                    if (today.date() !== _utilsLib.DateTimeHelper.GetLastDayOfMonth(today.month(), today.year())) {
                                        today = moment([today.year(), today.month(), _utilsLib.DateTimeHelper.GetLastDayOfMonth(today.month(), today.year())]);
                                    }
                                }
                            } else {
                                if (today.date() !== _utilsLib.DateTimeHelper.GetLastDayOfMonth(today.month(), today.year())) {
                                    today = moment([today.year(), today.month(), _utilsLib.DateTimeHelper.GetLastDayOfMonth(today.month(), today.year())]);
                                }
                            }
                        }
                        break;
                    }
                case '10':
                    {
                        //First
                        if (max) {
                            if (max.isBefore(today) === true) {
                                if (max.month() === today.month()) {
                                    today = moment([max.year(), max.month(), 1]);
                                } else {
                                    today = max;
                                    if (today.date() !== _utilsLib.DateTimeHelper.GetLastDayOfMonth(today.month(), today.year())) {
                                        today = moment([today.year(), today.month(), 1]);
                                    }
                                }
                            } else {
                                if (today.date() !== 1) {
                                    today = moment([today.year(), today.month(), 1]);
                                }
                            }
                        }
                        if (min) {
                            if (min.isAfter(today) === true) {
                                if (min.month() === today.month()) {
                                    today = moment([min.year(), min.month() + 1, 1]);
                                } else {
                                    today = min;
                                    if (today.date() !== 1) {
                                        today = moment([today.year(), today.month(), 1]);
                                    }
                                }
                            } else {
                                if (today.date() !== 1) {
                                    today = moment([today.year(), today.month(), 1]);
                                }
                            }
                        }
                        break;
                    }
                case '11':
                    {
                        //First und Last
                        if (max) {
                            if (max.isBefore(today) === true) {
                                if (max.month() === today.month()) {

                                    if (max.date() !== _utilsLib.DateTimeHelper.GetLastDayOfMonth(max.month(), max.year()) || max.date() !== 1) {
                                        today = moment([max.year(), max.month(), 1]);
                                    }
                                } else {
                                    if (max.date() !== _utilsLib.DateTimeHelper.GetLastDayOfMonth(max.month(), max.year())) {
                                        today = moment([max.year(), max.month(), 1]);
                                    } else {
                                        today = max;
                                    }
                                }
                            } else {
                                if (today.date() !== _utilsLib.DateTimeHelper.GetLastDayOfMonth(today.month(), today.year())) {
                                    today = moment([today.year(), today.month(), 1]);
                                }
                            }
                        }
                        if (min) {
                            if (min.isAfter(today) === true) {
                                if (min.month() === today.month()) {
                                    if (min.date() !== _utilsLib.DateTimeHelper.GetLastDayOfMonth(min.month(), min.year()) || min.date() !== 1) {
                                        today = moment([min.year(), min.month(), _utilsLib.DateTimeHelper.GetLastDayOfMonth(min.month(), min.year())]);
                                    }
                                } else {
                                    if (min.date() !== _utilsLib.DateTimeHelper.GetLastDayOfMonth(min.month(), min.year())) {
                                        today = moment([min.year(), min.month(), 1]);
                                    } else {
                                        today = min;
                                    }
                                }
                            } else {
                                if (min.month() === today.month()) {
                                    if (min.date() !== _utilsLib.DateTimeHelper.GetLastDayOfMonth(min.month(), min.year()) || min.date() !== 1) {
                                        today = moment([min.year(), min.month(), _utilsLib.DateTimeHelper.GetLastDayOfMonth(min.month(), min.year())]);
                                    }
                                } else {
                                    if (today.date() !== _utilsLib.DateTimeHelper.GetLastDayOfMonth(today.month(), today.year()) && today.date() !== 1) {
                                        today = moment([today.year(), today.month(), 1]);
                                    }
                                }
                            }
                        }
                        break;
                    }
                default:
                    break;
            }

            return today;
        }
        //#endregion

        //#region setzte Werte für Selectboxen

    }, {
        key: 'setNewValues',
        value: function setNewValues(me) {
            //setze Werte für Selectboxen Monat und Jahr
            document.getElementById("sfMonth" + me.state.id).value = me.state.currentMonth;
            document.getElementById("sfYear" + me.state.id).value = me.state.currentYear;
            /*let CalenderText = this.props.CalenderText ? this.props.CalenderText : [Vas.getText('Calendar','January') ,
                                                                                    Vas.getText('Calendar','February') ,
                                                                                    Vas.getText('Calendar','March') ,
                                                                                    Vas.getText('Calendar','April') ,
                                                                                    Vas.getText('Calendar','May') ,
                                                                                    Vas.getText('Calendar','June') ,
                                                                                    Vas.getText('Calendar','July') ,
                                                                                    Vas.getText('Calendar','August') ,
                                                                                    Vas.getText('Calendar','September') ,
                                                                                    Vas.getText('Calendar','October') ,
                                                                                    Vas.getText('Calendar','November') ,
                                                                                    Vas.getText('Calendar','December') ];
              let docs = document.getElementsByClassName("ss-selected-option");
            for(let i = 0; i < docs.length; i++){
                if(docs[i].parentElement.getAttribute("data-ss-uuid") === document.getElementById("sfMonth"+me.state.id).getAttribute("data-ss-uuid")){
                    docs[i].innerHTML = CalenderText[me.state.currentMonth];
                }
                if(docs[i].parentElement.getAttribute("data-ss-uuid") === document.getElementById("sfYear"+me.state.id).getAttribute("data-ss-uuid")){
                    docs[i].innerHTML = me.state.currentYear;
                }
            }*/
        }
    }, {
        key: 'GetYears',
        value: function GetYears() {
            //lege alle Jahre für Selectfeld Jahr fest

            var years = this.props.MaxYearsInFuture === null || this.props.MaxYearsInFuture === undefined ? 5 : this.props.MaxYearsInFuture;

            var data = [];
            var today = moment();
            var minYear = today.year() - 100;
            var maxYear = today.year() + years;
            var newMinYear = minYear;
            var newMaxYear = maxYear;
            for (var i = minYear; i <= maxYear; i++) {
                var insert = true;
                if (this.state.MinValue) {
                    newMinYear = this.state.MinValue.year();
                    if (Number(i) < this.state.MinValue.year()) {
                        insert = false;
                    }
                }

                if (this.state.MaxValue) {

                    newMaxYear = this.state.MaxValue.year();
                    if (Number(i) > this.state.MaxValue.year()) {
                        insert = false;
                    }
                }

                if (insert === true) {
                    data.push({ Key: Number(i), Display: i });
                }
            }
            return [data, newMinYear, newMaxYear];
        }
        //#endregion

        //#region Auswählen und schließen

    }, {
        key: 'Close',
        value: function Close() //schließe Picker und setState für neue Werte von currentYear,Month,Day
        {
            var _this3 = this;

            var x = (0, _jquery2.default)("#" + this.state.referenceId).val();
            var day = moment();
            if (!x) {
                day = moment();
            } else {
                day = _utilsLib.DateTimeHelper.StringToDate(x, false, this.props.Language);
            }
            (0, _jquery2.default)("#" + this.state.referenceId).focus();

            this.setState({ currentMonth: day.month(), currentYear: day.year() }, function () {
                _this3.setNewValues(_this3);
                _this3.props.reference.ClosePicker(_this3.props.reference);
            });
        }
    }, {
        key: 'GetDate',
        value: function GetDate(year, month, day) //ermittle gewähltes Datum -->schließen
        {
            document.getElementById(this.state.referenceId).value = _utilsLib.DateTimeHelper.FormatToShortDateString(moment([year, month, day]), this.state.ShowDay);
            this.Close();
        }
        //#endregion

        //#region Ändern des Monats/Jahr über Vor und Zurück oder Selectboxen

        //#region Step vor und zurück

    }, {
        key: 'Next',
        value: function Next(me) {
            var _this4 = this;

            if (this.state.ShowDay === true) {
                if (me.state.currentMonth === 11) {
                    if (Number(me.state.currentYear) + 1 <= this.state.years[2]) {
                        me.setState({ currentMonth: 0, currentYear: Number(me.state.currentYear) + 1 }, function () {
                            me.setWeekLines();
                            me.setNewValues(me);
                        });
                    }
                } else {
                    me.setState({ currentMonth: Number(me.state.currentMonth) + 1 }, function () {
                        me.setWeekLines();
                        me.setNewValues(me);
                    });
                }
            } else {
                if (me.state.currentMonth === 11) {
                    if (Number(me.state.currentYear) + 1 <= this.state.years[2]) {
                        if (this.state.MaxValue) {
                            if (moment([Number(me.state.currentYear) + 1, 0, 1]).isAfter(this.state.MaxValue, "month") === false) {

                                me.setState({ currentMonth: 0, currentYear: Number(me.state.currentYear) + 1 }, function () {
                                    _this4.SetMonthData();
                                    me.setWeekLines();
                                });
                            }
                        } else {
                            me.setState({ currentMonth: 0, currentYear: Number(me.state.currentYear) + 1 }, function () {
                                _this4.SetMonthData();
                                me.setWeekLines();
                            });
                        }
                    }
                } else {
                    if (this.state.MaxValue) {
                        if (moment([Number(me.state.currentYear), Number(me.state.currentMonth) + 1, 1]).isAfter(this.state.MaxValue, "month") === false) {
                            me.setState({ currentMonth: Number(me.state.currentMonth) + 1 }, function () {
                                _this4.SetMonthData();
                                me.setWeekLines();
                            });
                        }
                    } else {
                        me.setState({ currentMonth: Number(me.state.currentMonth) + 1 }, function () {
                            _this4.SetMonthData();
                            me.setWeekLines();
                        });
                    }
                }
            }
        }
    }, {
        key: 'Previous',
        value: function Previous(me) {
            var _this5 = this;

            if (this.state.ShowDay === true) {
                if (me.state.currentMonth === 0) {
                    if (Number(me.state.currentYear) - 1 >= this.state.years[1]) {
                        me.setState({ currentMonth: 11, currentYear: Number(me.state.currentYear) - 1 }, function () {
                            me.setWeekLines();
                            me.setNewValues(me);
                        });
                    }
                } else {
                    me.setState({ currentMonth: Number(me.state.currentMonth) - 1 }, function () {
                        me.setWeekLines();
                        me.setNewValues(me);
                    });
                }
            } else {
                if (me.state.currentMonth === 0) {
                    if (Number(me.state.currentYear) - 1 >= this.state.years[1]) {
                        if (this.state.MinValue) {
                            if (moment([Number(me.state.currentYear) - 1, 11, 1]).isBefore(this.state.MinValue, "month") === false) {
                                me.setState({ currentMonth: 11, currentYear: Number(me.state.currentYear) - 1 }, function () {
                                    _this5.SetMonthData();
                                    me.setWeekLines();
                                });
                            }
                        } else {
                            me.setState({ currentMonth: 11, currentYear: Number(me.state.currentYear) - 1 }, function () {
                                _this5.SetMonthData();
                                me.setWeekLines();
                            });
                        }
                    }
                } else {
                    if (this.state.MinValue) {
                        if (moment([Number(me.state.currentYear), Number(me.state.currentMonth) - 1, 1]).isBefore(this.state.MinValue, "month") === false) {
                            me.setState({ currentMonth: Number(me.state.currentMonth) - 1 }, function () {
                                _this5.SetMonthData();
                                me.setWeekLines();
                            });
                        }
                    } else {
                        me.setState({ currentMonth: Number(me.state.currentMonth) - 1 }, function () {
                            _this5.SetMonthData();
                            me.setWeekLines();
                        });
                    }
                }
            }
        }
    }, {
        key: 'SetMonthData',
        value: function SetMonthData() {
            var _this6 = this;

            var CalenderText = this.props.CalenderText ? this.props.CalenderText : [_Vas2.default.getText('Calendar', 'January'), _Vas2.default.getText('Calendar', 'February'), _Vas2.default.getText('Calendar', 'March'), _Vas2.default.getText('Calendar', 'April'), _Vas2.default.getText('Calendar', 'May'), _Vas2.default.getText('Calendar', 'June'), _Vas2.default.getText('Calendar', 'July'), _Vas2.default.getText('Calendar', 'August'), _Vas2.default.getText('Calendar', 'September'), _Vas2.default.getText('Calendar', 'October'), _Vas2.default.getText('Calendar', 'November'), _Vas2.default.getText('Calendar', 'December')];

            var monthArray = [{ Key: 0, Display: CalenderText[0] }, { Key: 1, Display: CalenderText[1] }, { Key: 2, Display: CalenderText[2] }, { Key: 3, Display: CalenderText[3] }, { Key: 4, Display: CalenderText[4] }, { Key: 5, Display: CalenderText[5] }, { Key: 6, Display: CalenderText[6] }, { Key: 7, Display: CalenderText[7] }, { Key: 8, Display: CalenderText[8] }, { Key: 9, Display: CalenderText[9] }, { Key: 10, Display: CalenderText[10] }, { Key: 11, Display: CalenderText[11] }];

            if (this.state.ShowDay === true) {
                monthArray = [{ Key: 0, Display: CalenderText[0] }, { Key: 1, Display: CalenderText[1] }, { Key: 2, Display: CalenderText[2] }, { Key: 3, Display: CalenderText[3] }, { Key: 4, Display: CalenderText[4] }, { Key: 5, Display: CalenderText[5] }, { Key: 6, Display: CalenderText[6] }, { Key: 7, Display: CalenderText[7] }, { Key: 8, Display: CalenderText[8] }, { Key: 9, Display: CalenderText[9] }, { Key: 10, Display: CalenderText[10] }, { Key: 11, Display: CalenderText[11] }];
            } else {
                var lastMonth = 11;
                if (this.state.MaxValue && !this.state.MinValue) {
                    if (Number(this.state.currentYear) === this.state.MaxValue.year()) {
                        lastMonth = this.state.MaxValue.month();
                        monthArray = [];
                        for (var i = 0; i <= lastMonth; i++) {
                            monthArray.push({ Key: i, Display: CalenderText[i] });
                        }
                    }
                }

                if (this.state.MinValue) {
                    if (this.state.MaxValue) {
                        if (this.state.MaxValue.year() === this.state.MinValue.year()) {
                            lastMonth = this.state.MaxValue.year();
                        } else {
                            lastMonth = 11;
                        }
                    } else {
                        lastMonth = 11;
                    }

                    if (Number(this.state.currentYear) === this.state.MinValue.year()) {
                        var firstMonth = this.state.MinValue.month();
                        monthArray = [];
                        for (var _i = firstMonth; _i <= lastMonth; _i++) {
                            monthArray.push({ Key: _i, Display: CalenderText[_i] });
                        }
                    }
                }
            }
            this.refs["sfMonth" + this.state.id].setState({ Data: monthArray }, function () {
                _this6.setNewValues(_this6);
            });
        }
        //#endregion

        //#region ausgewählter wert in Selectboxen geändert

    }, {
        key: 'setDate',
        value: function setDate(me) {
            me.setState({ currentMonth: parseInt(document.getElementById("sfMonth" + me.state.id).value, 10), currentYear: parseInt(document.getElementById("sfYear" + me.state.id).value, 10) }, function () {
                me.setWeekLines();
                me.SetMonthData();
            });
        }
        //#endregion

        //#endregion  

        //#region Methoden für render

        //#region füllen der Woche

    }, {
        key: 'HelperPickerFirstLast',
        value: function HelperPickerFirstLast(k, pickerFirstLast) {
            var _this7 = this;

            var day = this.getselectedDay();
            switch (pickerFirstLast) {
                case '00':
                    {
                        //let day = this.getselectedDay();
                        //style: { backgroundColor: '#1d5c87' },
                        if (day.year() === this.state.currentYear && day.month() === this.state.currentMonth && day.date() === k) {

                            var kontrastNumber = localStorage.getItem('Kontrast');

                            if (kontrastNumber == "true") {
                                return _react2.default.createElement(
                                    'td',
                                    {
                                        id: this.state.id + "_" + this.state.currentYear + "_" + this.state.currentMonth + "_" + k,
                                        className: "datePickerDaySelectedDay",
                                        style: { backgroundColor: '#1d5c87' },
                                        onClick: function onClick() {
                                            _this7.GetDate(_this7.state.currentYear, _this7.state.currentMonth, k);
                                        } },
                                    k
                                );
                            } else {
                                return _react2.default.createElement(
                                    'td',
                                    {
                                        id: this.state.id + "_" + this.state.currentYear + "_" + this.state.currentMonth + "_" + k,
                                        className: "datePickerDaySelectedDay",
                                        onClick: function onClick() {
                                            _this7.GetDate(_this7.state.currentYear, _this7.state.currentMonth, k);
                                        } },
                                    k
                                );
                            }
                        } else {
                            return _react2.default.createElement(
                                'td',
                                {
                                    id: this.state.id + "_" + this.state.currentYear + "_" + this.state.currentMonth + "_" + k,
                                    className: "datePickerDay",
                                    onClick: function onClick() {
                                        _this7.GetDate(_this7.state.currentYear, _this7.state.currentMonth, k);
                                    } },
                                k
                            );
                        }
                    }
                case '01':
                    {
                        return this.HelperLastDay(k, day);
                    }
                case '10':
                    {
                        return this.HelperFirstDay(k, day);
                    }
                case '11':
                    {
                        return this.HelperFirstLastDay(k, day);
                    }
                default:
                    break;
            }
        }
    }, {
        key: 'HelperFirstDay',
        value: function HelperFirstDay(k, day) {
            var _this8 = this;

            //prüft ist Tag erster Tag des Monats
            if (k === 1) {
                // eslint-disable-next-line no-undef
                if (day.year() === this.state.currentYear && day.month() === this.state.currentMonth && day.date() === k) {
                    return _react2.default.createElement(
                        'td',
                        {
                            id: this.state.id + "_" + this.state.currentYear + "_" + this.state.currentMonth + "_" + k,
                            className: "datePickerDaySelectedDay",
                            onClick: function onClick() {
                                _this8.GetDate(_this8.state.currentYear, _this8.state.currentMonth, k);
                            } },
                        k
                    );
                } else {
                    // eslint-disable-next-line no-unused-expressions
                    _react2.default.createElement(
                        'td',
                        {
                            id: this.state.id + "_" + this.state.currentYear + "_" + this.state.currentMonth + "_" + k,
                            className: "datePickerDay",
                            onClick: function onClick() {
                                _this8.GetDate(_this8.state.currentYear, _this8.state.currentMonth, k);
                            } },
                        k
                    );
                }
            } else {
                //aktuelle Tag ist nach dem !. des Monats
                return _react2.default.createElement(
                    'td',
                    {
                        id: this.state.id + "_" + this.state.currentYear + "_" + this.state.currentMonth + "_" + k,
                        className: "datePickerDayMin" },
                    k
                );
            }
        }
    }, {
        key: 'HelperLastDay',
        value: function HelperLastDay(k, day) {
            var _this9 = this;

            //prüft ist Tag letzter Tag des Monats
            if (k === _utilsLib.DateTimeHelper.GetLastDayOfMonth(this.state.currentMonth, this.state.currentYear)) {
                // eslint-disable-next-line no-undef
                if (day.year() === this.state.currentYear && day.month() === this.state.currentMonth && day.date() === k) {
                    return _react2.default.createElement(
                        'td',
                        {
                            id: this.state.id + "_" + this.state.currentYear + "_" + this.state.currentMonth + "_" + k,
                            className: "datePickerDaySelectedDay",
                            onClick: function onClick() {
                                _this9.GetDate(_this9.state.currentYear, _this9.state.currentMonth, k);
                            } },
                        k
                    );
                } else {
                    return _react2.default.createElement(
                        'td',
                        {
                            id: this.state.id + "_" + this.state.currentYear + "_" + this.state.currentMonth + "_" + k,
                            className: "datePickerDay",
                            onClick: function onClick() {
                                _this9.GetDate(_this9.state.currentYear, _this9.state.currentMonth, k);
                            } },
                        k
                    );
                }
            } else {
                //aktuelle Tag ist nach dem !. des Monats
                return _react2.default.createElement(
                    'td',
                    {
                        id: this.state.id + "_" + this.state.currentYear + "_" + this.state.currentMonth + "_" + k,
                        className: "datePickerDayMin" },
                    k
                );
            }
        }
    }, {
        key: 'HelperFirstLastDay',
        value: function HelperFirstLastDay(k, day) {
            var _this10 = this;

            //prüft ist Tag erster oder letzter Tag des Monats
            if (k === 1 || k === _utilsLib.DateTimeHelper.GetLastDayOfMonth(this.state.currentMonth, this.state.currentYear)) {
                //akteulle Tag liegt vor min Tag
                // eslint-disable-next-line no-undef
                if (day.year() === this.state.currentYear && day.month() === this.state.currentMonth && day.date() === k) {
                    return _react2.default.createElement(
                        'td',
                        {
                            id: this.state.id + "_" + this.state.currentYear + "_" + this.state.currentMonth + "_" + k,
                            className: "datePickerDaySelectedDay",
                            onClick: function onClick() {
                                _this10.GetDate(_this10.state.currentYear, _this10.state.currentMonth, k);
                            } },
                        k
                    );
                } else {
                    return _react2.default.createElement(
                        'td',
                        {
                            id: this.state.id + "_" + this.state.currentYear + "_" + this.state.currentMonth + "_" + k,
                            className: "datePickerDay",
                            onClick: function onClick() {
                                _this10.GetDate(_this10.state.currentYear, _this10.state.currentMonth, k);
                            } },
                        k
                    );
                }
            } else {
                //aktuelle Tag ist = oder nach dem min Tag
                return _react2.default.createElement(
                    'td',
                    {
                        id: this.state.id + "_" + this.state.currentYear + "_" + this.state.currentMonth + "_" + k,
                        className: "datePickerDayMin" },
                    k
                );
            }
        }
        //#endregion
        //#endregion

    }, {
        key: 'getPickerMinMax',
        value: function getPickerMinMax() {
            var pickerMinMax = ''; // -> 4 Zeichen "MinValue, MaxValue, First, Last" 0=false, 1= true
            if (this.state.MinValue) {
                pickerMinMax += '1';
            } else {
                pickerMinMax += '0';
            }

            if (this.state.MaxValue) {
                pickerMinMax += '1';
            } else {
                pickerMinMax += '0';
            }
            return pickerMinMax;
        }
    }, {
        key: 'getPickerFirstLast',
        value: function getPickerFirstLast() {
            var pickerFirstLast = '';
            if (this.props.First) {
                pickerFirstLast += '1';
            } else {
                pickerFirstLast += '0';
            }

            if (this.props.Last) {
                pickerFirstLast += '1';
            } else {
                pickerFirstLast += '0';
            }
            return pickerFirstLast;
        }
    }, {
        key: 'setWeekLines',
        value: function setWeekLines() {
            var _this11 = this;

            if (this.state.ShowDay === true) {
                _reactDom2.default.unmountComponentAtNode(document.getElementById('weekLines'));
                var start = moment([this.state.currentYear, this.state.currentMonth, 1]);

                var weeks = new Array(5);
                for (var j = 0; j <= 5; j++) {
                    weeks[j] = new Array(8);
                }
                var currentWeekIndex = 0;

                for (var i = 1; i <= _utilsLib.DateTimeHelper.GetLastDayOfMonth(this.state.currentMonth, this.state.currentYear); i++) {
                    var currentWeekday = moment([start.year(), start.month(), i]).day();
                    if (currentWeekday === 0) {
                        weeks[currentWeekIndex][7] = i;
                    } else {
                        weeks[currentWeekIndex][currentWeekday] = i;
                    }
                    if (currentWeekday === 0) {
                        currentWeekIndex++;
                    }
                }

                var pickerMinMax = this.getPickerMinMax();
                var pickerFirstLast = this.getPickerFirstLast();
                _reactDom2.default.render(weeks.map(function (p) {
                    //p->Woche
                    var currentCalendarWeek = "";
                    for (var _i2 = 1; _i2 <= 7; _i2++) //Ermittlung Kalenderwoche
                    {
                        if (p[_i2] > 0 && p[_i2] < 32) {
                            currentCalendarWeek = _utilsLib.DateTimeHelper.GetCalendarWeekForGivenDate(moment([_this11.state.currentYear, _this11.state.currentMonth, p[_i2]]));
                        } else {
                            p[_i2] = "";
                        }
                    }
                    //füllen der Woche

                    return (
                        // eslint-disable-next-line react/jsx-key
                        _react2.default.createElement(
                            'tr',
                            { key: currentCalendarWeek },
                            _react2.default.createElement(
                                'td',
                                {
                                    className: "datePickerCW",
                                    id: "dp" },
                                ' ',
                                currentCalendarWeek
                            ),
                            p.map(function (k) {
                                //k->Tag in Woche
                                if (k === "") //Tage aus Vormonat und Folgemonat, die noch auf dem Kalenderblatt sichtbar sind
                                    {
                                        return _react2.default.createElement(
                                            'td',
                                            {
                                                id: _this11.state.id + "_" + _this11.state.currentYear + "_" + _this11.state.currentMonth + "_" + k,
                                                className: "datePickerDay2" },
                                            k
                                        );
                                    } else {
                                    var currentDay = moment([_this11.state.currentYear, _this11.state.currentMonth, k]);
                                    switch (pickerMinMax) {
                                        case '00':
                                            {
                                                //KEIN MinValue und KEIN MaxValue
                                                return _this11.HelperPickerFirstLast(k, pickerFirstLast);
                                            }
                                        case '01':
                                            {
                                                //KEIN Min Value und Max Value
                                                if (currentDay.isAfter(_this11.state.MaxValue, 'day') === true) {
                                                    return _react2.default.createElement(
                                                        'td',
                                                        {
                                                            id: _this11.state.id + "_" + _this11.state.currentYear + "_" + _this11.state.currentMonth + "_" + currentDay.date(),
                                                            className: "datePickerDayMin" },
                                                        currentDay.date()
                                                    );
                                                } else {
                                                    return _this11.HelperPickerFirstLast(k, pickerFirstLast);
                                                }
                                            }
                                        case '10':
                                            {
                                                // MinValue und KEIN max Value
                                                if (currentDay.isBefore(_this11.state.MinValue, 'day') === true) {
                                                    return _react2.default.createElement(
                                                        'td',
                                                        {
                                                            id: _this11.state.id + "_" + _this11.state.currentYear + "_" + _this11.state.currentMonth + "_" + currentDay.date(),
                                                            className: "datePickerDayMin" },
                                                        currentDay.date()
                                                    );
                                                } else {
                                                    return _this11.HelperPickerFirstLast(k, pickerFirstLast);
                                                }
                                            }
                                        case '11':
                                            {
                                                //MinValue UND MaxValue
                                                if (currentDay.isBetween(_this11.state.MinValue, _this11.state.MaxValue, 'day', []) === false) {
                                                    return _react2.default.createElement(
                                                        'td',
                                                        {
                                                            id: _this11.state.id + "_" + _this11.state.currentYear + "_" + _this11.state.currentMonth + "_" + currentDay.date(),
                                                            className: "datePickerDayMin" },
                                                        currentDay.date()
                                                    );
                                                } else {
                                                    return _this11.HelperPickerFirstLast(k, pickerFirstLast);
                                                }
                                            }
                                        default:
                                            break;
                                    }
                                }
                            })
                        )
                    );
                }), document.getElementById('weekLines'));
            }
        }
    }, {
        key: 'LogoClick',
        value: function LogoClick() {

            var kontrastNumber = localStorage.getItem('Kontrast');

            if (kontrastNumber == "true") {

                (0, _jquery2.default)('#PopUpBoxdpCancelationDateHeader').attr('style', 'background-color: #1d5c87;');
                (0, _jquery2.default)('#PopUpBoxdpContractEndHeader').attr('style', 'background-color: #1d5c87;');
                (0, _jquery2.default)('#PopUpBoxdpDateOfBirthHeader').attr('style', 'background-color: #1d5c87;');
                (0, _jquery2.default)('#PopUpBoxdpValidFromHeader').attr('style', 'background-color: #1d5c87;');
                (0, _jquery2.default)('#PopUpBoxdpValidToHeader').attr('style', 'background-color: #1d5c87;');

                (0, _jquery2.default)('.pagingButtonPicker').attr('style', 'width: 30px; height: 30px; background-color: #1d5c87;');
                (0, _jquery2.default)('#ebChoose').attr('style', 'width: 170px; float: left; background-color: #1d5c87;');
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this12 = this;

            var CalenderText = this.props.CalenderText ? this.props.CalenderText : [_Vas2.default.getText('Calendar', 'January'), _Vas2.default.getText('Calendar', 'February'), _Vas2.default.getText('Calendar', 'March'), _Vas2.default.getText('Calendar', 'April'), _Vas2.default.getText('Calendar', 'May'), _Vas2.default.getText('Calendar', 'June'), _Vas2.default.getText('Calendar', 'July'), _Vas2.default.getText('Calendar', 'August'), _Vas2.default.getText('Calendar', 'September'), _Vas2.default.getText('Calendar', 'October'), _Vas2.default.getText('Calendar', 'November'), _Vas2.default.getText('Calendar', 'December')];

            var CalenderWeekDayText = this.props.CalenderWeekDayText ? this.props.CalenderWeekDayText : [_Vas2.default.getText('Calendar', 'CW'), _Vas2.default.getText('Calendar', 'Monday'), _Vas2.default.getText('Calendar', 'Tuesday'), _Vas2.default.getText('Calendar', 'Wednesday'), _Vas2.default.getText('Calendar', 'Thursday'), _Vas2.default.getText('Calendar', 'Friday'), _Vas2.default.getText('Calendar', 'Saturday'), _Vas2.default.getText('Calendar', 'Sunday')];
            //#region baue Seite zusammen

            var height = null;

            var bodyTable = _react2.default.createElement('table', null);
            if (this.state.ShowDay === true) {
                bodyTable = _react2.default.createElement(
                    'table',
                    null,
                    _react2.default.createElement(
                        'thead',
                        null,
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'th',
                                null,
                                CalenderWeekDayText[0]
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                CalenderWeekDayText[1]
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                CalenderWeekDayText[2]
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                CalenderWeekDayText[3]
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                CalenderWeekDayText[4]
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                CalenderWeekDayText[5]
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                CalenderWeekDayText[6]
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                CalenderWeekDayText[7]
                            )
                        )
                    ),
                    _react2.default.createElement('tbody', { id: 'weekLines' })
                );
            } else if (this.state.ShowDay === false) {
                height = 70;
                bodyTable = _react2.default.createElement(
                    'table',
                    null,
                    _react2.default.createElement(
                        'tbody',
                        null,
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                null,
                                _react2.default.createElement(_ExtendedButton2.default, {
                                    Id: "ebChoose",
                                    Usable: true,
                                    Text: _Vas2.default.getText("Labels", "ChooseDate"),
                                    Float: "left",
                                    Width: 170,
                                    OnClick: function OnClick() {
                                        _this12.GetDate(_this12.state.currentYear, _this12.state.currentMonth, _utilsLib.DateTimeHelper.GetLastDayOfMonth(_this12.state.currentMonth, _this12.state.currentYear));
                                    } })
                            )
                        )
                    )
                );
            }
            return _react2.default.createElement(_PopUpBox2.default, {
                Content: _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'table',
                        null,
                        _react2.default.createElement('thead', null),
                        _react2.default.createElement(
                            'tbody',
                            null,
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement('td', { width: '18px' }),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement(_PagingButton2.default, {
                                        Id: "pbBack" + this.state.id,
                                        Width: 30,
                                        onClick: function onClick() {
                                            _this12.Previous(_this12);
                                        },
                                        text: _react2.default.createElement(_Icon2.default, {
                                            AppURL: this.props.AppURL,
                                            Name: "Left",
                                            Size: 24,
                                            Color: "white",
                                            Align: "left",
                                            PaddingRight: '5px',
                                            PaddingLeft: '3px',
                                            PaddingTop: '3px' }),
                                        Type: "Picker" })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement(_SelectField2.default, {
                                        Id: "sfMonth" + this.state.id,
                                        ref: "sfMonth" + this.state.id,
                                        Width: 100,
                                        OnChange: function OnChange() {
                                            _this12.setDate(_this12);
                                        },
                                        Tooltip: this.props.TooltipMonth ? this.props.TooltipMonth : _Vas2.default.getText('Tooltips', 'Month'),
                                        Selected: true,
                                        Default: this.state.currentMonth,
                                        Float: 'left',
                                        Picker: true,
                                        Data: [{ Key: 0, Display: CalenderText[0] }, { Key: 1, Display: CalenderText[1] }, { Key: 2, Display: CalenderText[2] }, { Key: 3, Display: CalenderText[3] }, { Key: 4, Display: CalenderText[4] }, { Key: 5, Display: CalenderText[5] }, { Key: 6, Display: CalenderText[6] }, { Key: 7, Display: CalenderText[7] }, { Key: 8, Display: CalenderText[8] }, { Key: 9, Display: CalenderText[9] }, { Key: 10, Display: CalenderText[10] }, { Key: 11, Display: CalenderText[11] }],
                                        OnBlur: this.props.onBlur,
                                        Height: height
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement(_SelectField2.default, {
                                        Id: "sfYear" + this.state.id,
                                        ref: "sfYear" + this.state.id,
                                        Width: 70,
                                        OnChange: function OnChange() {
                                            _this12.setDate(_this12);
                                        },
                                        Tooltip: this.props.TooltipYear ? this.props.TooltipYear : _Vas2.default.getText('Tooltips', 'Year'),
                                        Selected: true,
                                        Default: this.state.currentYear,
                                        Float: 'left',
                                        Picker: true,
                                        Data: this.state.years[0],
                                        OnBlur: this.props.onBlur,
                                        Height: height
                                    })
                                ),
                                _react2.default.createElement(
                                    'td',
                                    null,
                                    _react2.default.createElement(_PagingButton2.default, {
                                        Id: "pbNext" + this.state.id,
                                        Width: 30,
                                        onClick: function onClick() {
                                            _this12.Next(_this12);
                                        },
                                        text: _react2.default.createElement(_Icon2.default, {
                                            AppURL: this.props.AppURL,
                                            Name: "Right",
                                            Size: 24,
                                            Color: "white",
                                            Align: "left",
                                            PaddingRight: '5px',
                                            PaddingLeft: '4px',
                                            PaddingTop: '3px' }),
                                        Type: "Picker" })
                                )
                            )
                        )
                    ),
                    bodyTable
                ),
                Id: this.props.Id,
                me: this,
                modal: false,
                Title: _react2.default.createElement(
                    'div',
                    null,
                    this.props.ChooseDataText ? this.props.ChooseDataText : _Vas2.default.getText('Labels', 'ChooseDate'),
                    ' ',
                    _react2.default.createElement(_Icon2.default, {
                        AppURL: this.props.AppURL,
                        Name: "Close",
                        Style: { cursor: 'pointer' },
                        Size: 24,
                        Color: "white",
                        Align: "right",
                        OnClick: function OnClick() {
                            _this12.props.reference.ClosePicker(_this12.props.reference);
                        }
                    })
                ),
                Width: 330,
                Z: 9999
            });
            //#endregion
        }
    }]);

    return DatePicker;
}(_react.Component);

exports.default = DatePicker;